(function () {
  function rafThrottle(fn) {
    let id = 0;
    let args;
    let ctx;
    return function () {
      args = arguments;
      ctx = this;
      if (id) return;
      id = requestAnimationFrame(function () {
        id = 0;
        fn.apply(ctx, args);
      });
    };
  }

  function parseJson(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    if (window.apx && window.apx.Currency && typeof window.apx.Currency.formatMoney === 'function') {
      return window.apx.Currency.formatMoney(cents, format || (window.apx.settings && window.apx.settings.moneyFormat) || window.apx.moneyFormat || '${{amount}}');
    }
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (format && format.indexOf('{{amount}}') > -1) return format.replace('{{amount}}', amount);
    return amount;
  }

  function optionKey(index) {
    const n = Number(index || 0) + 1;
    return 'option' + n;
  }

  function init(el) {
    if (el.getAttribute('data-sticky-initialized') === 'true') return;
    el.setAttribute('data-sticky-initialized', 'true');

    if (!el.hasAttribute('data-portalized')) {
      document.body.appendChild(el);
      el.setAttribute('data-portalized', 'true');
    }

    el.style.display = '';

    const sectionRoot = document.getElementById(el.getAttribute('data-target-id')) || el.closest('.product-section') || document;
    const mainForm = document.getElementById(el.getAttribute('data-main-form-id')) || sectionRoot.querySelector('form[id^="AddToCartForm-"]') || sectionRoot.querySelector('form[action="/cart/add"]') || sectionRoot.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;

    const behavior = el.getAttribute('data-behavior') || 'add_to_cart';
    const scrollOffsetDesktop = parseFloat(el.getAttribute('data-scroll-offset-desktop') || '120');
    const scrollOffsetMobile = parseFloat(el.getAttribute('data-scroll-offset-mobile') || '90');
    const triggerMode = el.getAttribute('data-trigger-mode') || 'form';
    const triggerPercent = Math.min(100, Math.max(0, parseFloat(el.getAttribute('data-trigger-scroll-percent') || '30')));
    const stickyForm = el.querySelector('form');
    const moneyFormat = el.getAttribute('data-money-format') || '';
    const stickyVariantJson = parseJson(el.querySelector('[data-sticky-variants]'));
    const sectionVariantJson = parseJson(sectionRoot.querySelector('[data-variant-json]'));
    const variants = stickyVariantJson.length ? stickyVariantJson : sectionVariantJson;
    const button = el.querySelector('button[name="add"]');
    const stickyIdField = el.querySelector('[data-sticky-variant-id]') || el.querySelector('input[name="id"]');
    const priceWrap = el.querySelector('[data-sticky-price]');
    const currentPriceEl = el.querySelector('[data-sticky-current-price]');
    const comparePriceEl = el.querySelector('[data-sticky-compare-price]');
    const variantWrap = el.querySelector('.sticky-atc__details__variant');
    const variantTitleEl = el.querySelector('.sticky-atc__details__variant__title');
    const optionSelects = Array.from(el.querySelectorAll('.sticky-atc__select'));
    const imgWrap = el.querySelector('.sticky-atc__image');

    const getVariantIdField = function () {
      return mainForm.querySelector('input[name="id"], select[name="id"]');
    };

    function headerOffset() {
      const h = document.querySelector('.amz-sec-hdr') || document.querySelector('.amz-hdr') || document.querySelector('.section-header') || document.querySelector('.site-header');
      return h ? h.offsetHeight : 0;
    }

    function scrollStopOffset() {
      return window.matchMedia('(min-width: 768px)').matches ? scrollOffsetDesktop : scrollOffsetMobile;
    }

    function scrollToProductForm() {
      const target = mainForm || sectionRoot.querySelector('form[action*="/cart/add"]') || sectionRoot;
      if (!target) return;
      const y = target.getBoundingClientRect().top + window.pageYOffset - scrollStopOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function setBottomOffset() {
      const vv = window.visualViewport;
      let offset = 0;
      if (vv) offset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
      const prev = parseFloat(el.getAttribute('data-bottom-offset') || '0');
      if (Math.abs(prev - offset) < 2) return;
      el.setAttribute('data-bottom-offset', String(offset));
      el.style.setProperty('--sticky-atc-bottom', offset + 'px');
    }

    // Cache the page's total scroll height instead of reading
    // doc.scrollHeight / document.body.scrollHeight on every scroll frame.
    // This listener is bound to window, so it runs on every scroll
    // anywhere on the page - reading a layout property like scrollHeight
    // right after anything else has written to the DOM/style forces a
    // full-page layout recalculation. Keeping a cached value updated only
    // when content actually resizes removes that read from the hot
    // scroll path entirely.
    let cachedDocH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    function refreshDocH() {
      cachedDocH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(refreshDocH).observe(document.body);
    } else {
      window.addEventListener('resize', refreshDocH);
      window.addEventListener('load', refreshDocH);
    }

    function scrollState() {
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const viewportH = window.innerHeight || doc.clientHeight || 0;
      const docH = cachedDocH;
      const scrollable = Math.max(0, docH - viewportH);
      const progress = scrollable ? (scrollTop / scrollable) * 100 : 100;
      const bottomProgress = docH ? (scrollTop + viewportH) / docH : 0;
      return { progress: progress, bottomProgress: bottomProgress };
    }

    function setFooterHide() {
      const state = scrollState();
      const shouldHide = state.bottomProgress >= 0.9;
      if (document.documentElement.classList.contains('scrolled-to-bottom') !== shouldHide) {
        document.documentElement.classList.toggle('scrolled-to-bottom', shouldHide);
      }
    }

    const onScroll = rafThrottle(function () {
      const state = scrollState();
      const rect = mainForm.getBoundingClientRect();
      const hide = triggerMode === 'percent' ? state.progress < triggerPercent : rect.top > headerOffset();
      if (el.classList.contains('sticky-atc--out') !== hide) {
        el.classList.toggle('sticky-atc--out', hide);
      }
      setFooterHide();
      setBottomOffset();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
      window.visualViewport.addEventListener('resize', onScroll);
    }

    function variantById(id) {
      if (!id) return null;
      return variants.find(function (v) {
        return String(v.id) === String(id);
      }) || null;
    }

    function selectedOptionValues() {
      const values = {};
      sectionRoot.querySelectorAll('[data-variant-input]').forEach(function (input) {
        const index = input.getAttribute('data-index') || (input.closest('.variant-input-wrap') && input.closest('.variant-input-wrap').getAttribute('data-index')) || '';
        if (!index) return;
        const type = (input.getAttribute('type') || input.tagName || '').toLowerCase();
        if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
        if (input.value) values[index] = input.value;
      });
      const ordered = Object.keys(values).sort(function (a, b) {
        return parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10);
      }).map(function (key) {
        return values[key];
      });
      if (!ordered.length) {
        optionSelects.forEach(function (sel) {
          if (sel.value) ordered.push(sel.value);
        });
      }
      return ordered;
    }

    function variantByOptions(values) {
      if (!values.length) return null;
      return variants.find(function (v) {
        const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i] && opts[i] !== values[i]) return false;
        }
        return true;
      }) || null;
    }

    function selectedVariant() {
      const idField = getVariantIdField();
      const fromId = idField && idField.value ? variantById(idField.value) : null;
      if (fromId) return fromId;
      return variantByOptions(selectedOptionValues());
    }

    function syncVariantTitle(variant) {
      if (!variantTitleEl) return;
      let txt = '';
      if (variant && variant.options && variant.options.length) txt = variant.options[0] || '';
      if (!txt) {
        const values = selectedOptionValues();
        if (values.length) txt = values[0] || '';
      }
      variantTitleEl.textContent = txt;
      if (variantWrap) variantWrap.hidden = !txt;
    }

    function syncSelectsFromVariant(variant) {
      if (!variant || !variant.options) return;
      optionSelects.forEach(function (sel, index) {
        if (variant.options[index] !== undefined) sel.value = variant.options[index];
      });
    }

    function syncSelectsFromMain() {
      optionSelects.forEach(function (sel, index) {
        const mainInput = sectionRoot.querySelector('[data-variant-input][data-index="option' + (index + 1) + '"]:checked') ||
          sectionRoot.querySelector('.variant-input-wrap[data-index="option' + (index + 1) + '"] select');
        if (mainInput && mainInput.value) sel.value = mainInput.value;
      });
    }

    function setBusy(isBusy) {
      if (!button) return;
      button.disabled = !!isBusy;
      button.classList.toggle('btn--loading', !!isBusy);
    }

    function buttonText(attr, fallback) {
      return el.getAttribute(attr) || fallback || '';
    }

    function showError(text) {
      if (!text) return;
      let errorEl = el.querySelector('[data-sticky-error]');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.setAttribute('data-sticky-error', '');
        el.appendChild(errorEl);
      }
      errorEl.textContent = text;
      errorEl.hidden = false;
      window.clearTimeout(el.__stickyErrorTimer);
      el.__stickyErrorTimer = window.setTimeout(function () {
        errorEl.hidden = true;
      }, 4000);
    }

    let lastSrc = '';

    function updateState(variant) {
      syncVariantTitle(variant);
      syncSelectsFromVariant(variant);
      if (stickyIdField) stickyIdField.value = variant ? variant.id : '';

      const available = !!(variant && variant.available);
      if (button) {
        button.disabled = !variant || !available;
        const label = variant
          ? (available ? buttonText('data-add-text', button.getAttribute('data-add-text')) : buttonText('data-sold-out-text', button.getAttribute('data-sold-out-text')))
          : buttonText('data-unavailable-text', button.getAttribute('data-unavailable-text'));
        const labelEl = button.querySelector('[data-sticky-btn-text]') || button;
        if (label) labelEl.textContent = label;
      }

      if (priceWrap && currentPriceEl) {
        const price = variant ? variant.price : null;
        const comparePrice = variant ? variant.compare_at_price : null;
        if (price != null) {
          currentPriceEl.textContent = formatMoney(price, moneyFormat);
          const onSale = comparePrice && comparePrice > price;
          if (comparePriceEl) {
            comparePriceEl.hidden = !onSale;
            if (onSale) comparePriceEl.textContent = formatMoney(comparePrice, moneyFormat);
          }
        }
      }
    }

    function getVariantImageSrc(variant) {
      if (!variant) return '';
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return variant.featured_media.preview_image.src;
      }
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') return variant.featured_image;
        if (variant.featured_image.src) return variant.featured_image.src;
      }
      return '';
    }

    function getVariantImageAlt(variant) {
      if (!variant) return '';
      if (variant.featured_image && typeof variant.featured_image !== 'string' && variant.featured_image.alt) return variant.featured_image.alt;
      if (variant.featured_media && variant.featured_media.alt) return variant.featured_media.alt;
      if (variant.title) return variant.title;
      return '';
    }

    function getActiveMainImg() {
      const sels = [
        '.product__main-photos .product-main-slide.is-selected picture img',
        '.product__main-photos .product-main-slide.is-selected img',
        '.product__main-photos [aria-hidden="false"] img',
        '.product__main-photos img',
        '.product__photos img',
        '[data-product-single-media-wrapper][aria-hidden="false"] img',
        '[data-product-single-media-wrapper] img'
      ];
      for (let i = 0; i < sels.length; i += 1) {
        const node = sectionRoot.querySelector(sels[i]);
        if (node && (node.currentSrc || node.src)) return node;
      }
      return null;
    }

    function normalizeSrc(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) return window.location.protocol + src;
      return src;
    }

    const updateImg = rafThrottle(function (variant) {
      if (!imgWrap) return;
      const selected = variant || selectedVariant();
      const fallbackImg = getActiveMainImg();
      const newSrc = normalizeSrc(getVariantImageSrc(selected) || (!lastSrc && fallbackImg && (fallbackImg.currentSrc || fallbackImg.src)) || '');
      if (!newSrc || newSrc === lastSrc) return;
      let stickyImg = imgWrap.querySelector('img');
      if (!stickyImg) {
        stickyImg = document.createElement('img');
        stickyImg.loading = 'lazy';
        if ('decoding' in stickyImg) stickyImg.decoding = 'async';
        imgWrap.innerHTML = '';
        imgWrap.appendChild(stickyImg);
      }
      stickyImg.alt = getVariantImageAlt(selected) || (fallbackImg && fallbackImg.alt) || '';
      stickyImg.src = newSrc;
      lastSrc = newSrc;
      if (fallbackImg) {
        fallbackImg.addEventListener('load', function () {
          const latest = fallbackImg.currentSrc || fallbackImg.src || '';
          if (!getVariantImageSrc(selected) && latest && latest !== lastSrc) {
            stickyImg.src = latest;
            lastSrc = latest;
          }
        }, { once: true });
      }
    });

    function burstUpdateImg(variant) {
      updateImg(variant);
      setTimeout(function () { updateImg(variant); }, 60);
      setTimeout(function () { updateImg(variant); }, 150);
      setTimeout(function () { updateImg(variant); }, 300);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product__thumb') || e.target.closest('[data-product-thumb]')) setTimeout(function () { burstUpdateImg(); }, 60);
    });

    mainForm.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('fieldset.variant-input-wrap') || e.target.matches('[data-variant-input]'))) {
        syncSelectsFromMain();
        setTimeout(function () { updateState(selectedVariant()); }, 0);
        burstUpdateImg();
      }
    });

    sectionRoot.addEventListener('variantChange', function (e) {
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : selectedVariant();
      updateState(variant);
      burstUpdateImg(variant);
    });

    document.addEventListener('variant:change', function (e) {
      if (e && e.detail && e.detail.sectionId) {
        const thisId = sectionRoot.getAttribute('data-section-id') || sectionRoot.dataset.sectionId;
        if (thisId && String(e.detail.sectionId) !== String(thisId)) return;
      }
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : selectedVariant();
      updateState(variant);
      burstUpdateImg(variant);
    });

    const idField = getVariantIdField();
    if (idField && 'MutationObserver' in window) {
      new MutationObserver(function () {
        updateState(selectedVariant());
      }).observe(idField, { attributes: true, attributeFilter: ['value'] });
    }

    const gallery = sectionRoot.querySelector('.product__main-photos') || sectionRoot;
    if ('MutationObserver' in window && gallery) {
      new MutationObserver(function () { burstUpdateImg(); }).observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'srcset', 'data-current', 'data-media-id', 'aria-hidden', 'style']
      });
    }

    function submitMain(variantId) {
      let idField = getVariantIdField();
      if (!idField) {
        idField = document.createElement('input');
        idField.type = 'hidden';
        idField.name = 'id';
        mainForm.appendChild(idField);
      }
      if (variantId) idField.value = String(variantId);
      setBusy(true);
      const btn = mainForm.querySelector('button[name="add"]');
      if (typeof mainForm.requestSubmit === 'function') {
        try {
          if (btn) btn.disabled = false;
          mainForm.requestSubmit(btn || null);
        } catch (e) {
          btn ? btn.click() : mainForm.submit();
        }
      } else if (btn) {
        btn.click();
      } else {
        mainForm.submit();
      }
      setTimeout(function () {
        setBusy(false);
        const html = document.documentElement;
        const drawer = document.getElementById('CartDrawer') || document.querySelector('[id*="CartDrawer"]');
        const isOpen = html.classList.contains('js-drawer-open') || (drawer && drawer.classList.contains('is-open')) || (drawer && drawer.getAttribute('aria-hidden') === 'false');
        if (!isOpen && drawer) {
          drawer.classList.add('is-open');
          html.classList.add('js-drawer-open', 'js-drawer-open-right');
        }
      }, 800);
    }

    function onStickySubmit(e) {
      if (behavior === 'scroll') {
        e.preventDefault();
        scrollToProductForm();
        return;
      }
      e.preventDefault();
      const variant = selectedVariant();
      if (!variant || !variant.available) {
        const text = !variant ? buttonText('data-unavailable-text', el.getAttribute('data-error-text')) : buttonText('data-sold-out-text', el.getAttribute('data-error-text'));
        showError(text);
        scrollToProductForm();
        return;
      }
      submitMain(variant.id);
    }

    if (stickyForm) stickyForm.addEventListener('submit', onStickySubmit);

    el.addEventListener('click', function (e) {
      const scrollLink = e.target.closest('.sticky-atc__buttons a');
      if (!scrollLink || behavior !== 'scroll') return;
      e.preventDefault();
      scrollToProductForm();
    });

    syncSelectsFromMain();
    updateState(selectedVariant());
    burstUpdateImg();
    setBottomOffset();
    setFooterHide();
    requestAnimationFrame(onScroll);
  }

  function initAll() {
    const seen = new Set();
    document.querySelectorAll('sticky-atc').forEach(function (el) {
      const key = el.getAttribute('data-target-id') || 'global';
      if (seen.has(key)) {
        el.remove();
        return;
      }
      seen.add(key);
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
})();